import { render, staticRenderFns } from "./InsuranceAuthorizationRecipePatientFormA.vue?vue&type=template&id=4a8c53cc&scoped=true&"
import script from "./InsuranceAuthorizationRecipePatientFormA.vue?vue&type=script&lang=js&"
export * from "./InsuranceAuthorizationRecipePatientFormA.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceAuthorizationRecipePatientFormA.vue?vue&type=style&index=0&id=4a8c53cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8c53cc",
  null
  
)

export default component.exports